import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../../styles/GlobalStyles';

const base = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 10px;
  transition: all 0.25s ease;
  text-decoration: none;
  border: none;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;

  &:hover { transform: translateY(-1px) scale(1.02); }
  &:active { transform: scale(0.97); }
`;

const primaryStyle = css`
  background: ${theme.gradient};
  color: #fff;
  box-shadow: 0 0 28px rgba(97,93,255,0.35);
  &:hover { box-shadow: 0 0 40px rgba(97,93,255,0.55); }
`;

const secondaryStyle = css`
  background: rgba(255,255,255,0.05);
  color: ${theme.text};
  border: 1px solid rgba(255,255,255,0.12);
  backdrop-filter: blur(10px);
  &:hover {
    background: rgba(97,93,255,0.1);
    border-color: rgba(97,93,255,0.4);
    color: #fff;
    box-shadow: 0 0 20px rgba(97,93,255,0.2);
  }
`;

const StyledButton = styled.button`
  ${base}
  ${props => props.primary   && primaryStyle}
  ${props => props.secondary && secondaryStyle}
`;

const LinkButton = styled(Link)`
  ${base}
  ${props => props.primary   && primaryStyle}
  ${props => props.secondary && secondaryStyle}
`;

const AnchorButton = styled.a`
  ${base}
  ${props => props.primary   && primaryStyle}
  ${props => props.secondary && secondaryStyle}
`;

const Button = ({ children, primary, secondary, onClick, to, href, ...rest }) => {
  if (to) return <LinkButton to={to} primary={primary} secondary={secondary} {...rest}>{children}</LinkButton>;
  if (href) return <AnchorButton href={href} primary={primary} secondary={secondary} {...rest}>{children}</AnchorButton>;
  return <StyledButton primary={primary} secondary={secondary} onClick={onClick} {...rest}>{children}</StyledButton>;
};

export default Button;
